"use strict";

document.addEventListener("DOMContentLoaded", function () {
  //Document Ready

  //Get an array of all Modals on the Page && pair with their links
  var modals = document.querySelectorAll('.modal');

  if (modals.length > 0) {
    document.querySelector('body').insertAdjacentHTML('afterbegin', `<div class="modal-overlay" tabindex="-1"></div>`);
  }

  //Modal Setup
  modals.forEach((modal) => {
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('tabindex', '-1');
    let height = modal.getAttribute('data-modal-height');
    if (height !== undefined) {
      modal.style.height = `height: ${height}px;`;
    }
  });
  //Find modal links in content and set them up
  document.querySelectorAll('.open-modal').forEach((lnk) => {

    // console.log('Modal Link Setup');

    lnk.on('click', function (e) {
      // console.log('Link Clicked');
      let modal = document.getElementById(lnk.getAttribute('href').substring(1));
      if (modal.classList.contains('modal-inline')) {

        // console.log('Open Inline Modal');
        //Keep Modal Inline
        openModalInline(modal, e);
        setupModalEvents(modal);
      } else {
        // console.log('Open Copied Modal');
        //Copy Modal Out of DOM
        var modalCopy = modal.cloneNode(true);

        var mdReplaceWith = `<span data-modalid="${modal.getAttribute('id').substring(0)}" aria-hidden="true" hidden="hidden"></span>`;

        modal.insertAdjacentHTML('afterend', mdReplaceWith);

        document.querySelector('.modal-overlay').insertAdjacentElement('afterend', modalCopy);
        openModalCopied(modalCopy, e);
      }
    });
  });
});

//Open a modal
function openModalInline(modal, event) {
  // console.log('openModalInline');
  if (event !== 'default open') {
    event.preventDefault();
  }

  document.querySelectorAll('html, body').forEach((el) => {
    el.classList.toggle('modal-open');
  });
  document.querySelector('.modal-overlay').classList.toggle('show-modal');
  document.querySelector('.modal-overlay').classList.toggle('modal-inline');

  modal.removeAttribute('hidden');
  modal.setAttribute('aria-hidden', 'false');
  modal.setAttribute('tabindex', '0');
  modal.classList.toggle('show-modal');

  document.querySelector('.modal-content .close-modal').setAttribute('tabindex', '0');
  document.querySelector('.modal-content .close-modal').classList.add('modal-inline');
  modal.focus();

  //Keep keyboard events within modal content
  modalFocusTrap(modal);
}

//Open a copied modal
function openModalCopied(modal, event) {
  // console.log('openModalInline');
  if (event !== 'default open') {
    event.preventDefault();
  }

  document.querySelectorAll('html, body').forEach((el) => {
    el.classList.toggle('modal-open');
  });
  document.querySelector('.modal-overlay').classList.toggle('show-modal');
  document.querySelector('.modal-overlay').classList.toggle('modal-inline');

  modal.removeAttribute('hidden');
  modal.setAttribute('aria-hidden', 'false');
  modal.setAttribute('tabindex', '0');
  modal.classList.toggle('show-modal');

  document.querySelector('.modal-content .close-modal').setAttribute('tabindex', '0');
  document.querySelector('.modal-content .close-modal').classList.add('modal-inline');
  modal.focus();

  //Keep keyboard events within modal content
  modalFocusTrap(modal);
  setupModalEvents(modal);
}

function setupModalEvents(modal) {

  //Focus Modal Content when tabbed to
  if (document.querySelector('.modal-overlay') !== null) {
    document.querySelector('.modal-overlay').on('click', function () {
      // console.log('Overlay Click');
      let currentModalID = document.querySelectorAll('.modal').forEach((modal) => {
        if (window.getComputedStyle(modal).display !== 'none') {
          closeModal(modal);
        }
      });
    });
  }

  //Close modal events from close modal buttons
  document.querySelectorAll('.close-modal').forEach((m) => {
    // console.log('Close Modal Setup');
    m.on('click', function (e) {
      // console.log('Close Modal Click');
      let modalP = m.parentNode.parentNode;
      closeModal(modalP);
    });

    m.on('keydown', function (e) {
      // console.log('Close Modal Key');
      e.preventDefault();
      if (e.which === 13) {
        let modalP = m.parentNode.parentNode;
        closeModal(modalP);
      }
    });
  });

  //Close modal on escape key
  document.on('keyup', function (e) {
    if (e.keyCode === 27) {
      // console.log('Esc Setup');
      let currentModalID = document.querySelectorAll('.modal').forEach((modal) => {
        // console.log('Esc');
        if (window.getComputedStyle(modal).display !== 'none') {
          closeModal(modal);
        }
      });
    }
  });
}

//Close a modal
function closeModal(modal) {
  // console.log('closeModal');
  //Close the Modal
  document.querySelectorAll('html, body').forEach((el) => {
    el.classList.remove('modal-open');
  });

  document.querySelector('.modal-overlay').classList.remove('show-modal');

  modal.classList.remove('show-modal');
  modal.setAttribute('hidden', 'hidden');
  modal.setAttribute('aria-hidden', 'true');
  modal.setAttribute('tabindex', '-1');

  //Focus on modal link toggle when modal is closed
  let modalLink = document.querySelector(`[href*="#${modal.getAttribute('id')}"]`);
  if (modalLink !== undefined && modalLink !== null) {
    modalLink.focus();
    modalLink = undefined;
  }
}

//Trap focus within an open modal
function modalFocusTrap(modal) {
  // console.log('modalFocusTrap');
  let modalFocusEl = modal.querySelectorAll('span.close-modal, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

  let modalFocusableFirstEl,
    modalFocusableLastEl;

  modal.querySelectorAll('*').forEach((el) => {
    if (([].indexOf.call(el, modalFocusEl) > -1) && modalFocusEl.length > 1) {
      if (modalFocusableFirstEl !== undefined) {
        modalFocusableFirstEl = el;
      } else {
        modalFocusableLastEl = el;
      }
    } else {
      modalFocusableFirstEl = el;
      modalFocusableLastEl = el;
    }
  });

  modalFocusableFirstEl.on('keydown', function (e) {
    if (e.which === 9 && e.shiftKey) {
      e.preventDefault();
      modalFocusableLastEl.focus();
    }
  });

  modalFocusableLastEl.on('keydown', function (e) {
    if (e.which === 9 && !e.shiftKey) {
      e.preventDefault();
      modalFocusableFirstEl.focus();
    }
  });

}